var _path, _path2, _circle, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSexual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8506 132C61.6365 132 31.361 110.131 20 99.5036C34.9433 96.3358 70.6025 90 93.6929 90C116.783 90 152.852 96.3358 168 99.5036C155.206 110.131 122.065 132 91.8506 132Z",
    fill: "#DA675D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.278 70C61.2066 70 32.8963 89.522 20 99.283C52.5477 102.604 67.2863 98.0755 76.4979 98.0755C85.7095 98.0755 84.4813 102 93.3859 102C102.29 102 100.141 98.0755 112.73 98.0755C125.32 98.0755 119.793 100.792 140.058 100.792C156.271 100.792 165.441 99.7862 168 99.283C153.568 89.522 122.31 70 112.73 70C100.755 70 98.6058 74.5283 93.3859 74.5283C88.166 74.5283 83.8672 70 71.278 70Z",
    fill: "#F38E88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 93.5,
    r: 87,
    stroke: "#4091F7",
    strokeWidth: 13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6133,
    y: 152.363,
    width: 184,
    height: 13,
    transform: "rotate(-41.3207 21.6133 152.363)",
    fill: "#4091F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSexual);
export default __webpack_public_path__ + "static/media/IcSexual.99dd0bcee5164bb43419359337ff31cf.svg";
export { ForwardRef as ReactComponent };